import axios, { AxiosRequestConfig, isAxiosError } from "axios"

import URLS from "~/constants/urls"

export const axiosInstance = axios.create({
  baseURL: URLS.V1,
  headers: {
    "Content-Type": "application/json"
  }
})

export const fetchDataOnServer = async (
  options: AxiosRequestConfig,
  request: Request
) => {
  try {
    const response = await axios({
      ...options,
      headers: {
        ...options.headers
      }
    })
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response?.status === 401) {
        try {
          const { logout } = await import("~/session")
          await logout(request)
        } catch {
          // do nothing
        }
        return {
          error: error.response.data?.error?.message,
          status: error.response?.status
        }
      } else if (error.response?.status === 400) {
        return {
          error: error.response.data?.error?.message,
          status: error.response?.status
        }
      } else {
        return {
          error: error.response?.data?.error?.message,
          status: error.response?.status
        }
      }
    }
    throw error
  }
}
